import actionTypes from "../actionTypes";
import * as zpCTypPraceUtils from "../../utils/ciselniky/zpCTypPraceUtils";

export const changeTypPrace = (typPrace) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_TYP_PRACE,
      data: typPrace,
    });
  };
};
const getZP_C_TYP_PRACE_Request = () => ({
  type: actionTypes.GET_ZP_C_TYP_PRACE_REQUEST,
});
const getZP_C_TYP_PRACE_Success = (res) => ({
  type: actionTypes.GET_ZP_C_TYP_PRACE_SUCCESS,
  res,
});
const getZP_C_TYP_PRACE_Failure = (error) => ({
  type: actionTypes.GET_ZP_C_TYP_PRACE_FAILURE,
  error,
});
export const getZP_C_TYP_PRACE = () => {
  return async (dispatch) => {
    try {
      dispatch(getZP_C_TYP_PRACE_Request());
      let res = await zpCTypPraceUtils.getZP_C_TYP_PRACE();
      dispatch(getZP_C_TYP_PRACE_Success(res));
    } catch (error) {
      dispatch(getZP_C_TYP_PRACE_Failure(error));
    }
  };
};
